import { Controller } from "@hotwired/stimulus"
import { Dismissable } from "./concerns/dismissable"

export default class extends Controller {
  static values = { dismissId: String }

  initialize() {
    Dismissable(this, {id: this.dismissIdValue, expiration: 30})
  }

  connect() {
    if (this.wasDismissed()) this.element.classList.add("d-none")
  }
}
